
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultancy",
      function () {
        return require("private-next-pages/consultancy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultancy"])
      });
    }
  